export default {
  state: {
    selectedMeeting: null,
    selectedRace: null,
    selectedRunner: null,
    selectedBookie: null,
    selectedDate: null,
    selectedFormat: null,
    selectedCountry: null,
    selectedState: null,
    selectedCode: null
  },
  mutations: {
    setSelectedMeeting (state, meeting) {
      state.selectedMeeting = meeting
    },
    setSelectedRace (state, raceNumber) {
      state.selectedRace = raceNumber
    },
    setSelectedRunner (state, runnerNumber) {
      state.selectedRunner = runnerNumber
    },
    setSelectedBookie (state, source) {
      state.selectedBookie = source
    },
    setSelectedDate (state, date) {
      state.selectedDate = date
    },
    setSelectedFormat (state, format) {
      state.selectedFormat = format
    },
    setSelectedCountry (state, country) {
      state.selectedCountry = country
    },
    setSelectedState (state, stateA) {
      state.selectedState = stateA
    },
    setSelectedCode (state, code) {
      state.selectedCode = code
    }
  },
  actions: {
    setSelectedCountry (context, country) {
      context.commit('setSelectedCountry', country)
    },
    setSelectedState (context, stateA) {
      context.commit('setSelectedState', stateA)
    },
    setSelectedCode (context, code) {
      context.commit('setSelectedCode', code)
    },
    setSelectedFormat (context, format) {
      context.commit('setSelectedFormat', format)
    },
    setSelectedMeeting (context, meeting) {
      context.commit('setSelectedMeeting', meeting)
      context.commit('setSelectedRace', null)
      context.commit('setSelectedRunner', null)
    },
    setSelectedRace (context, { race, meeting }) {
      context.commit('setSelectedRace', race)
      context.commit('setSelectedMeeting', meeting)
      context.commit('setSelectedRunner', null)
    },
    setSelectedRunner (context, runnerNumber) {
      context.commit('setSelectedRunner', runnerNumber)
    },
    setSelectedBookie (context, source) {
      context.commit('setSelectedBookie', source)
    },
    setSelectedDate (context, date) {
      context.commit('setSelectedDate', date)
    },
    clearSelections (context) {
      context.commit('setSelectedMeeting', null)
      context.commit('setSelectedRace', null)
      context.commit('setSelectedRunner', null)
      context.commit('setSelectedBookie', null)
      context.commit('setSelectedDate', null)
      // context.commit('setSelectedCountry', null)
      // context.commit('setSelectedState', null)
      // context.commit('setSelectedCode', null)
    },
    clearSelectedRace (context) {
      context.commit('setSelectedRace', null)
      context.commit('setSelectedRunner', null)
    }
  },
  getters: {
    getSelectedMeeting (state) {
      return state.selectedMeeting
    },
    getSelectedRace (state) {
      return state.selectedRace
    },
    getSelectedRunner (state) {
      return state.selectedRunner
    },
    getSelectedBookie (state) {
      return state.selectedBookie
    },
    getBetsByCustomer (state) {
      return state.betsByCustomer
    },
    getBetsByType (state) {
      return state.betsBytype
    },
    getRaces (state) {
      return state.races
    },
    getRunners (state) {
      return state.runners
    },
    getPage (state) {
      return state.page
    },
    getSelectedFormat (state) {
      return state.selectedFormat
    },
    getTotalPages (state) {
      return state.totalPages
    },
    getSelections (state) {
      return {
        selectedMeeting: state.selectedMeeting,
        selectedRace: state.selectedRace,
        selectedRunner: state.selectedRunner,
        selectedBookie: state.selectedBookie,
        selectedDate: state.selectedDate
      }
    }
  }
}
